import { useParams, useRouter } from 'next/navigation';
import queryString from 'query-string';
import { useMemo, useState, useEffect } from 'react';

/**
 * read and write url hash, response to url hash change
 */
// Reference: https://github.com/vercel/next.js/discussions/49465#discussioncomment-8104991
export const useHash = () => {
  const getCurrentHash = useMemo(
    () => () =>
      typeof window !== 'undefined'
        ? window.location.hash.replace(/^#!?/, '')
        : '',
    []
  );
  const router = useRouter();
  const params = useParams();
  const [hash, _setHash] = useState<string>(getCurrentHash());

  const setHash = (newHash: string) => {
    let updatedUrl = window.location.href;
    updatedUrl = queryString.stringifyUrl({
      url: updatedUrl.split('#')[0] || '',
      fragmentIdentifier: newHash,
    });

    _setHash(newHash);
    router.replace(updatedUrl);
  };
  useEffect(() => {
    const currentHash = getCurrentHash();
    _setHash(currentHash);
  }, [getCurrentHash, params]);

  useEffect(() => {
    const handleHashChange = () => {
      const currentHash = getCurrentHash();
      _setHash(currentHash);
    };
    if (typeof window === 'undefined') return;
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [getCurrentHash]);

  return [hash, setHash] as const;
};
